import type { FaireProductEntity } from "../../entity_types/product";

export const p_u3tqahs8dw: FaireProductEntity = {
  token: "p_u3tqahs8dw",
  type: "product",
  name: "Slender Wine Glass - 6 Assorted",
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/33e1c1bf41e8e98b66b0dcf6674199e51f7439445cf6247988710ff834916f3d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b3e5572195ff30de9daf0af5838abdfe6d09ec92e71923c81ebe747615d4dc09.png",
    "https://cdn.faire.com/fastly/f3f0fef51e306889aa9edc26aef81641b3242fd9f9bbf5aeba6d4703f01d89d1.jpeg",
    "https://cdn.faire.com/fastly/f613fda513c5ae938dcfce7a16a74cabf7f8e1365fdfccf89bc2e1c3913872d1.jpeg",
    "https://cdn.faire.com/fastly/1abee86ddf0c2f6c98c73031f7bd59f2d783ddf130034cfd4ee8964b5bf71f51.jpeg",
    "https://cdn.faire.com/fastly/62eedab5538252262b6225115f0008118d1564978312bc48887758b65f8bfaca.jpeg",
    "https://cdn.faire.com/fastly/b0a0021899486d149aff4d754c7044af6bccb643f541766eafd1eb48753f00f9.jpeg",
    "https://cdn.faire.com/fastly/fcdbd8051b6665f8bdce6b5cc8eb0935a7185b140b63f3b6b2f9331228602193.jpeg",
  ],
  priceDollars: 7,
  description:
    "Celebrate special occasions in colorful, understated style with this Slender Glassware in 6 assorted colors. Crafted out of glass, each glass' sleek, streamlined shape is complemented by a subtly tinted stem — perfect for enhancing any dinner party or get-together. Available as a Wine Goblet and Champagne Flute. Each assortment contains 6 different colors. Price per item.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:10.796Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
